import type { ServiceEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "services";

const URLS = {
  create: BASE_URL,
  update: (serviceId: ServiceEntity.Schema["id"]) => [BASE_URL, serviceId].join(SLASH),
  delete: (serviceId: ServiceEntity.Schema["id"]) => [BASE_URL, serviceId].join(SLASH),
  get: (serviceId: ServiceEntity.Schema["id"]) => [BASE_URL, serviceId].join(SLASH),
  getAll: BASE_URL,
  getPaginated: [BASE_URL, "getPage"].join(SLASH),
};

export { URLS };
